//@ts-nocheck

import { StoredItem } from "LibMargoWorld/item";

export async function initTipApiFix() {
    /* Naprawa zepsutego garmorskiego API od tipów xD */

    // WHY CAN'T YOU PROPERLY CHECK IF ENGINE EXISTS
    window.Engine = void 0;

    // Wait for load
    while (!window.margonem) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
    }

    window.margonem.convertItemValue = (a) => a;

    window.margonem.getItemRarity = function (item) {
        const st = parseItemStat(item.stat);
        return st.rarity ?? "common";
    };
    // Gosh dang it
    window.$.inArray = function (value, array, fromIndex) {
        return Array.isArray(array) && array.includes(value, fromIndex);
    };
}

declare global {
    interface Window {
        MargoTipsParser: {
            getTip: (it: StoredItem) => string;
        };
    }
}
